import { Outlet } from 'react-router-dom'

const InitialClientLayout = () => {
  return <Outlet />;
}

export default InitialClientLayout